export default __webpack_public_path__ + "static/media/getjalin-img-modal.1a19e002.png";